export const openMailto = (email: string) => {
  const a = document.createElement('a');
  a.href = `mailto:${email}`;
  a.click();
};
